import { render, staticRenderFns } from "./stepSubmit.vue?vue&type=template&id=1aff5ce7&scoped=true&"
import script from "./stepSubmit.vue?vue&type=script&lang=js&"
export * from "./stepSubmit.vue?vue&type=script&lang=js&"
import style0 from "./stepSubmit.vue?vue&type=style&index=0&id=1aff5ce7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aff5ce7",
  null
  
)

export default component.exports